import styled from '@emotion/styled';

import { Button, forMobile } from '@/design-system';

export const PortfolioSection = styled('section')(({ theme }) => ({
  display: 'flex',
  minWidth: 0,
  flexDirection: 'column',
  gap: theme.spacing[24],

  [forMobile]: { gap: theme.spacing[16] },
}));

export const SectionHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: theme.spacing[12],
}));

export const SectionActions = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],

  [forMobile]: {
    width: '100%',

    '& > button, & > span': { flex: 1 },
    '& > span > button': { width: '100%' },
  },
}));

export const SectionActionButton = styled(Button)(({ theme }) => ({
  minHeight: theme.spacing[40],
}));

export const SectionBody = styled('div')({ minWidth: 0 });

export const MobileSections = styled('div')(({ theme }) => ({
  marginTop: theme.spacing[24],
}));

export const DesktopSections = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[40],
  marginTop: theme.spacing[40],
}));
